import React from "react";
import PropTypes from "prop-types";
import { Button, DotsGrid } from "@opendate-app/setlist";

function DragHandle({ label, ...handleProps }) {
  return (
    <Button
      variant="tertiary"
      size="xs"
      icon={DotsGrid}
      aria-label={label}
      className="classes-drag-handle"
      {...handleProps}
    />
  );
}

DragHandle.propTypes = { label: PropTypes.string.isRequired };

export default DragHandle;
